<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="420"
  >
    <v-card class="confirmation-dialog">
      <v-card-title class="text-h5" style="word-break: keep-all;">
        {{ confirmationDialog.header }}
      </v-card-title>
      <v-card-text>
        {{ confirmationDialog.body }}
        <v-otp-input
          v-if="requiresPin"
          id="otp-input"
          v-model="enteredPin"
          label="Ange admin pinkod"
          class="mt-6 mx-8"
          length="4"
          @finish="pinEntered"
        ></v-otp-input>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="error"
          text
          @click="show = false"
          :disabled="confirmationDialog.disableCancel"
        >
          Avbryt
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          @click="requiresPin ? pinEntered() : confirm()"
          color="success"
          text
          :disabled="isConfirmDisabled"
        >
          <span v-if="timeRemaining > 0" class="mr-2">({{ timeRemaining }})</span>
          <span>
            Bekräfta
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import AuthService from '@/services/AuthService'
import { mapState } from 'vuex'

export default {
  name: 'ConfirmationDialog',
  data: () => ({
    countdownEndsAt: null,
    countdownTimeout: null,
    timeRemaining: 0,
    enteredPin: '',
    pinError: ''
  }),
  computed: {
    ...mapState(
      {
        confirmationDialog: state => state.confirmationDialog
      }
    ),
    requiresPin: function () {
      return this.confirmationDialog.requiresPin
    },
    isConfirmDisabled: function () {
      if (this.timeRemaining > 0) {
        return true
      }
      if (this.confirmationDialog.requiresPin) {
        return !this.enteredPin || this.enteredPin.length !== 4
      }
      return false
    },
    show: {
      get () {
        return this.confirmationDialog.show
      },
      set (value) {
        if (!value) {
          this.$store.commit('SET_CLOSE_CONFIRMATION_DIALOG')
        }
      }
    }
  },
  methods: {
    startCountdown: function () {
      this.stopCountdown()

      const duration = process.env.NODE_ENV === 'production' ? 10 : 3
      this.countdownEndsAt = Date.now() + duration * 1000
      this.timeRemaining = duration
      this.scheduleCountdownTick()
    },
    scheduleCountdownTick: function () {
      const millisecondsRemaining = Math.max(this.countdownEndsAt - Date.now(), 0)
      this.timeRemaining = Math.ceil(millisecondsRemaining / 1000)

      if (this.timeRemaining === 0) {
        this.countdownTimeout = null
        return
      }

      const millisecondsUntilNextSecond = millisecondsRemaining - (this.timeRemaining - 1) * 1000
      this.countdownTimeout = setTimeout(() => {
        this.scheduleCountdownTick()
      }, millisecondsUntilNextSecond)
    },
    stopCountdown: function () {
      if (this.countdownTimeout) {
        clearTimeout(this.countdownTimeout)
      }
      this.countdownEndsAt = null
      this.countdownTimeout = null
      this.timeRemaining = 0
    },
    pinEntered: function () {
      if (!this.requiresPin || this.isConfirmDisabled) {
        return false
      }

      // bekräfta pinkod mot backend
      AuthService.verifyAuthCode({ authCode: this.enteredPin })
        .then(({ data }) => {
          if (data.status === 'success') {
            this.confirm()
          } else {
            this.$store.dispatch('snackbars/createSnackbar', {
              color: 'error',
              text: 'Felaktig pinkod'
            })
          }
          this.enteredPin = ''
          this.focusInput()
        })
    },
    confirm: function () {
      if (!this.confirmationDialog.confirmationFunction) {
        //
      } else if ((typeof this.confirmationDialog.confirmationFunction) === 'function') {
        this.confirmationDialog.confirmationFunction(this.confirmationDialog.confirmationArgument)
      } else {
        this.$store.dispatch(this.confirmationDialog.confirmationFunction, this.confirmationDialog.confirmationArgument)
      }
      this.show = false
    },
    focusInput: function () {
      const pinInput = document.querySelector('.confirmation-dialog input#otp-input--0')
      if (pinInput) {
        setTimeout(() => {
          pinInput.focus()
        }, 50)
      }
    }
  },
  watch: {
    'confirmationDialog.show': function (newVal) {
      if (!newVal) {
        // Dialog stängs
        this.stopCountdown()
        this.enteredPin = ''
      } else {
        // Dialog öppnas
        if (this.confirmationDialog.withTimer) {
          this.startCountdown()
        }
        if (this.requiresPin) {
          this.$nextTick(() => {
            this.focusInput()
          })
        }
      }
    }
  },
  beforeDestroy () {
    this.stopCountdown()
  }
}
</script>
